"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var COLLECTOR_BASE_URL = 'https://collector.schibsted.io';
var COLLECTOR_PATH = 'api/v1/track';
var CIS_BASE_URL = 'https://cis.schibsted.com';
exports.default = {
    collectorBaseUrl: COLLECTOR_BASE_URL,
    collectorPath: COLLECTOR_PATH,
    cisBaseUrl: CIS_BASE_URL,
    cisEnabled: true,
    eventDebounce: 200,
    environment: 'browser',
    useBeaconWhenAvailable: true,
};
